import React, { FC }          from 'react';
import styled                 from 'styled-components';
import { IInvoiceStatistics } from '@typings/invoiceManagement';
import { EAppPage }           from '@enums/common';
import { EInvoicePage }       from '@enums/invoiceManagement';
import {
  formatCurrency,
  getCurrentMonthName,
}                             from '@utils/commonFunctions';
import { LinkButton }         from '@components/index';

const Wrapper = styled.div`
  margin: 60px 0 20px 200px;

  h2 {
    font-size   : 18px;
    margin-left : 10px;
  }
`;

const ItemContainer = styled.div`
  display       : flex;
  margin-bottom : 5px;

  p {
    width      : 100px;
    text-align : right;
  }

  span {
    width      : 125px;
    text-align : right;
  }

  button {
    width           : 125px;
    margin          : 0;
    padding         : 0;
    justify-content : flex-end;
  }
`;

const DueContainer = styled.div`
  display     : flex;
  margin-left : 100px;
`;

interface IProps {
  push       : (path: string) => void;
  statistics : IInvoiceStatistics | null;
}

export const StatusDashboard: FC<IProps> = ({ push, statistics }) => {
  const {
    currentEstimate = 0,
    currentCount    = 0,
    over30DaysCount = 0,
    over60DaysCount = 0,
    over90DaysCount = 0,
    currentDue      = 0,
    pasDue          = 0,
    collected       = 0,
  } = statistics ?? {};

  return (
    <Wrapper>
      <h2>Invoice Status Dashboard</h2>

      <ItemContainer>
        <span>{getCurrentMonthName()} Estimate:</span>
        <p>{formatCurrency(currentEstimate)}</p>
      </ItemContainer>

      <ItemContainer>
        <span>Collected:</span>
        <p>{formatCurrency(collected)}</p>
      </ItemContainer>

      <ItemContainer>
        <>
          <LinkButton
            label   = "Current:"
            onClick = {(): void => push(`${EAppPage.InvoiceManagement}/${EInvoicePage.Current}`)}
          />
          <p>{currentCount}</p>
        </>

        <DueContainer>
          <LinkButton
            label   = "Current Due:"
            onClick = {(): void => push(`${EAppPage.InvoiceManagement}/${EInvoicePage.CurrentDue}`)}
          />
          <p>{formatCurrency(currentDue)}</p>
        </DueContainer>
      </ItemContainer>

      <ItemContainer>
        <>
          <LinkButton
            label   = "Over Thirty Days:"
            onClick = {(): void => push(`${EAppPage.InvoiceManagement}/${EInvoicePage.OverThirtyDays}`)}
          />
          <p>{over30DaysCount}</p>

          <DueContainer>
            <LinkButton
              label   = "Past Due:"
              onClick = {(): void => push(`${EAppPage.InvoiceManagement}/${EInvoicePage.PastDue}`)}
            />
            <p>{formatCurrency(pasDue)}</p>
          </DueContainer>
        </>
      </ItemContainer>

      <ItemContainer>
        <LinkButton
          label   = "Over Sixty Days:"
          onClick = {(): void => push(`${EAppPage.InvoiceManagement}/${EInvoicePage.OverSixtyDays}`)}
        />
        <p>{over60DaysCount}</p>
      </ItemContainer>

      <ItemContainer>
        <LinkButton
          label   = "Over Ninety Days:"
          onClick = {(): void => push(`${EAppPage.InvoiceManagement}/${EInvoicePage.OverNinetyDays}`)}
        />
        <p>{over90DaysCount}</p>
      </ItemContainer>
    </Wrapper>
  );
};
